import salesOrderSlice from './SalesOrderSlice'
import salesDashBoardSlice from './SalesDashboardSlice'
//import itemGradesCountSlice from './items-grades-counts/ItemsGradesCountSettingSlice.js';

const salesExecutiveSlices = {
    salesOrder: salesOrderSlice,
    salesDashboard:salesDashBoardSlice
};

export default salesExecutiveSlices;